<div class="card border-round-2xl p-0">
    <div class="col-12">
        <div class="w-12 pb-3 flex align-items-center justify-content-between">
            <h5 class="mb-0">{{ tableConfig.title }}</h5>
            <button pButton [label]="buttonText" class="p-button-outlined mb-2" icon="pi pi-plus-circle"
                (click)="onAdd($event)" *ngIf="showButton"></button>
        </div>
        <p-table #dt1 [value]="tableConfig.tableData" dataKey="id" [rows]="tableConfig.pagesize"
            [totalRecords]="tableConfig.totalRecords" [loading]="tableConfig.loading" [rowHover]="true"
            [rowsPerPageOptions]="[5,10, 15, 25]" styleClass="p-datatable-gridlines" [paginator]="true" [lazy]="true"
            (onLazyLoad)="pagination($event)" [globalFilterFields]="tableConfig.globalFilterFields"
            responsiveLayout="scroll">
            <ng-template pTemplate="caption">
                <div class="flex flex-row flex-wrap gap-3 align-items-center">

                    <!-- Search -->
                    <div class="w-full sm:w-20rem">
                        <span class="p-input-icon-left w-full">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" #filter (input)="onGlobalFilter(dt1, $event)"
                                placeholder="Search Keyword" class="w-full" />
                        </span>
                    </div>

                    <!-- Status -->
                    <div class="w-full sm:w-14rem" *ngIf="tableConfig.showStatusFilter !== false">
                        <p-dropdown class="w-full" [options]="statusOptions" [(ngModel)]="selectedStatus"
                            placeholder="Select Status" (onChange)="onStatusFilterChange()">
                        </p-dropdown>
                    </div>

                    <!-- State -->
                    <div class="w-full sm:w-14rem">
                        <p-dropdown *ngIf="tableConfig.showStateFilter" class="w-full" [options]="stateOptions"
                            [(ngModel)]="selectedState" placeholder="Select State"
                            (onChange)="onStateFilterChange($event)">
                        </p-dropdown>
                    </div>

                    <!-- Zone -->
                    <div class="w-full sm:w-14rem">
                        <p-dropdown *ngIf="tableConfig.showZoneFilter" class="w-full" [options]="zones$"
                            [(ngModel)]="selectedZone" placeholder="Select Zone" optionLabel="name" optionValue="code"
                            (onChange)="onZoneFilterChange($event)">
                        </p-dropdown>
                    </div>

                    <!-- Venue Type -->
                    <div class="w-full sm:w-14rem">
                        <p-dropdown *ngIf="tableConfig.showVenueTypeFilter" class="w-full" [options]="venueTypes"
                            [(ngModel)]="selectedVenueType" placeholder="Select Venue Type" optionLabel="label"
                            optionValue="value" (onChange)="onVenueTypeFilterChange($event)">
                        </p-dropdown>
                    </div>

                    <!-- Date Filters -->
                    <div class="w-full sm:w-auto">
                        <div *ngIf="tableConfig.showDateFilter" class="flex flex-wrap gap-2 align-items-center">
                            <p-calendar [(ngModel)]="filteredFromDate" placeholder="From Date" [showClear]="true"
                                [showIcon]="true" appendTo="body" dateFormat="dd/mm/yy">
                            </p-calendar>

                            <p-calendar [(ngModel)]="filteredToDate" placeholder="To Date" [showClear]="true"
                                [showIcon]="true" appendTo="body" dateFormat="dd/mm/yy">
                            </p-calendar>

                            <button pButton type="button" label="Go" icon="pi pi-check" class="p-button-primary"
                                (click)="applyDateFilter()">
                            </button>
                        </div>
                    </div>

                    <!-- Clear -->
                    <div class="w-full sm:w-auto sm:ml-auto">
                        <button pButton label="Clear" icon="pi pi-filter-slash"
                            class="p-button-outlined w-full sm:w-auto" (click)="clear(dt1)">
                        </button>
                    </div>

                </div>



            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <ng-container *ngFor="let item of tableConfig.tableColumns">
                        <th style="width: 10rem">
                            <div class="flex justify-content-between align-items-center">
                                {{ item.textName }}
                            </div>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer>
                <tr>
                    <ng-container *ngFor="let item of tableConfig.tableColumns">
                        <td>
                            <ng-container *ngIf="
                                    item.eventName !== 'button' &&
                                        item.eventName !== 'action' &&
                                        item.eventName !== 'image';
                                    else buttonIconComponent
                                ">
                                {{ customer[item.fieldName] | brandLabel }}
                            </ng-container>
                            <ng-template #buttonIconComponent>
                                <ng-container *ngIf="item.eventName === 'button'">
                                    <ng-container *ngFor="
                                            let btnItem of item.buttonOption
                                        ">
                                        <ng-container *ngIf="
                                                btnItem.eventName === 'ICON';
                                                else buttonComponent
                                            ">
                                            <span class="mr-3" [pTooltip]="btnItem.toolTip" *ngIf="
                                                    (customer[item.fieldName] &&
                                                        customer[item.fieldName]
                                                            .length) ||
                                                    btnItem.visible
                                                ">
                                                <i [class]="btnItem.icon" (click)="
                                                        onButtonEvent(
                                                            btnItem,
                                                            customer,
                                                            customer[
                                                                item.fieldName
                                                            ]
                                                        )
                                                    "></i>
                                                <ng-container *ngIf="
                                                        btnItem.showText &&
                                                        customer[
                                                            item.fieldName
                                                        ] &&
                                                        customer[item.fieldName]
                                                            .length
                                                    ">
                                                    ({{
                                                    customer[item.fieldName]
                                                    .length
                                                    }})
                                                </ng-container>
                                            </span>
                                        </ng-container>
                                        <ng-template #buttonComponent>
                                            <p-button class="p-button-outlined mr-2" [label]="btnItem.textName" (click)="
                                                    onButtonEvent(
                                                        btnItem,
                                                        customer,
                                                        customer[item.fieldName]
                                                    )
                                                "></p-button>
                                        </ng-template>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="item.eventName === 'action'">
                                    <ng-container *ngFor="
                                            let btnItem of item.actionOption
                                        ">
                                        <ng-container *ngIf="btnItem.visible">
                                            <i [class]="btnItem.icon" style="margin-right: 1rem" (click)="
                                                    actionEvent(
                                                        btnItem,
                                                        customer
                                                    )
                                                "></i>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="item.eventName === 'image'">
                                    <div class="w-fit m-auto">
                                        <p-image class="block" [src]="customer[item.fieldName]" [alt]="customer.name"
                                            width="100px" height="50px" [title]="customer.description"
                                            [preview]="true"></p-image>
                                    </div>
                                </ng-container>
                            </ng-template>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="9">No Content found.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
                <tr>
                    <td colspan="8">Loading Content. Please wait.</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>